import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Check } from 'lucide-react';
import Navbar from '../../components/website/Navbar';
import Footer from '../../components/website/Footer';
import { apiGet } from '../../lib/api';

const FALLBACK = [
  { name: 'Free', price: 0, customer_limit: 25, features: ['Customer management', 'Daily deliveries', 'Basic billing'] },
  { name: 'Starter', price: 499, customer_limit: 100, features: ['Everything in Free', 'Route management', 'AI assistant (basic)', 'Reports'] },
  { name: 'Growth', price: 999, customer_limit: 300, features: ['Everything in Starter', 'Multiple products', 'Advanced reports', 'WhatsApp reminders'] },
  { name: 'Business', price: 1999, customer_limit: 1000, features: ['Everything in Growth', 'Priority support', 'Custom pricing', 'API access'] },
];

export default function Pricing() {
  const [plans, setPlans] = useState(FALLBACK);
  useEffect(() => {
    apiGet('/pricing')
      .then((r) => { if (r.data?.length) setPlans(r.data); })
      .catch(() => {});
  }, []);
  return (
    <div className="bg-rozops-bg min-h-screen">
      <Navbar />
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-24">
        <div className="text-center max-w-3xl mx-auto">
          <div className="inline-flex items-center gap-1.5 rounded-full bg-rozops-green-light text-rozops-green text-xs font-semibold px-3 py-1">Pricing</div>
          <h1 className="mt-4 font-heading font-extrabold text-4xl sm:text-5xl text-rozops-navy tracking-tight">Simple pricing for growing businesses</h1>
          <p className="mt-4 text-lg text-rozops-text-muted">Start free. Upgrade when you grow. No commitment.</p>
        </div>
        <div className="mt-12 grid md:grid-cols-2 lg:grid-cols-4 gap-5">
          {plans.map((p, idx) => (
            <div key={p.name} className={`rounded-2xl p-6 border shadow-soft flex flex-col ${idx === 2 ? 'bg-rozops-navy text-white border-transparent shadow-medium' : 'bg-white border-gray-100'}`}>
              <div className={`text-xs uppercase tracking-widest font-bold ${idx === 2 ? 'text-white/60' : 'text-rozops-text-muted'}`}>{p.name}</div>
              <div className="mt-3 flex items-baseline gap-1">
                <span className={`font-heading font-extrabold text-4xl ${idx === 2 ? 'text-white' : 'text-rozops-navy'}`}>₹{p.price}</span>
                <span className={`text-sm ${idx === 2 ? 'text-white/60' : 'text-rozops-text-muted'}`}>/{p.billing_cycle || 'monthly'}</span>
              </div>
              <div className={`text-sm mt-1 ${idx === 2 ? 'text-white/70' : 'text-rozops-text-muted'}`}>
                {p.customer_limit ? `Up to ${p.customer_limit} customers` : 'Unlimited customers'}
              </div>
              <div className="mt-6 space-y-2 flex-1">
                {(p.features || []).map(f => (
                  <div key={f} className={`flex items-start gap-2 text-sm ${idx === 2 ? 'text-white/85' : 'text-rozops-text'}`}>
                    <Check className={`w-4 h-4 flex-shrink-0 mt-0.5 ${idx === 2 ? 'text-rozops-green' : 'text-rozops-green'}`} /> {f}
                  </div>
                ))}
              </div>
              <Link to="/register" data-testid={`plan-cta-${p.name.toLowerCase()}`} className={`mt-6 text-center rounded-xl px-4 py-2.5 font-semibold transition-all ${idx === 2 ? 'bg-white text-rozops-navy hover:bg-rozops-blue-light' : 'bg-rozops-blue text-white hover:bg-rozops-blue-dark'}`}>
                {p.price === 0 ? 'Start Free' : 'Get Started'}
              </Link>
            </div>
          ))}
        </div>
      </section>
      <Footer />
    </div>
  );
}
